import { useNotifications } from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api/utils'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { logError } from '@sequencehq/utils'

export const useUpdateNumeralMapping = () => {
  const { displayNotification } = useNotifications()

  const { mutateAsync: putTaxCategoryNumeralMapping } = useMutation(
    dashboardv99990101Client.putTaxCategoryNumeralMapping
  )

  return async ({
    taxCategoryId,
    numeralProductCategory,
    numeralProductCategoryTitle,
    isDefault
  }: {
    taxCategoryId: string
    numeralProductCategory: string
    numeralProductCategoryTitle: string
    isDefault?: boolean
  }) => {
    try {
      await putTaxCategoryNumeralMapping({
        taxCategoryId,
        body: {
          numeralProductCategory,
          numeralProductCategoryTitle,
          isDefault: isDefault ?? false
        }
      })

      displayNotification('Tax category mapping updated', {
        type: 'success'
      })
    } catch (error) {
      console.error('Failed to update numeral mapping:', error)
      logError(error)

      // Try to extract a more specific error message
      const errorMessage =
        error instanceof Error && error.message
          ? `Failed to update tax category mapping: ${error.message}`
          : 'Failed to update tax category mapping'

      displayNotification(errorMessage, {
        type: 'error'
      })
      throw error
    }
  }
}
